const FIELD_NAMES = {
  subject: ['subject'],
  pageContext: ['page_context'],
  pagePath: ['page_path'],
  templateContext: ['template_context'],
};

const findField = (root, names) => {
  for (const name of names) {
    const selector = [
      `input[name="${name}"]`,
      `textarea[name="${name}"]`,
      `select[name="${name}"]`,
    ].join(', ');
    const match = root.querySelector(selector);
    if (match) {
      return match;
    }
  }

  return null;
};

const setFieldValue = (field, value) => {
  if (!field || !value) {
    return;
  }

  field.value = value;
  field.setAttribute('value', value);
  field.dispatchEvent(new Event('input', { bubbles: true }));
  field.dispatchEvent(new Event('change', { bubbles: true }));
};

const hideFieldGroup = (field) => {
  if (!field) {
    return;
  }

  field.type = 'hidden';
  const group = field.closest('.ff-el-group, .ff-field_container, .ff-t-cell');
  if (group) {
    group.hidden = true;
  }
};

const initContextualQuoteForms = () => {
  const wrappers = document.querySelectorAll('[data-basic-quote-form]');

  wrappers.forEach((wrapper) => {
    const form = wrapper.querySelector('form');
    if (!form || form.dataset.contextualQuoteReady === 'true') {
      return;
    }

    const defaultSubject = String(wrapper.dataset.defaultSubject || '').trim();
    const pageContext = String(wrapper.dataset.pageContext || '').trim();
    const pagePath = String(wrapper.dataset.pagePath || '').trim();
    const templateContext = String(wrapper.dataset.templateContext || '').trim();

    const subjectField = findField(form, FIELD_NAMES.subject);
    const pageContextField = findField(form, FIELD_NAMES.pageContext);
    const pagePathField = findField(form, FIELD_NAMES.pagePath);
    const templateContextField = findField(form, FIELD_NAMES.templateContext);

    setFieldValue(subjectField, defaultSubject);
    setFieldValue(pageContextField, pageContext);
    setFieldValue(pagePathField, pagePath);
    setFieldValue(templateContextField, templateContext);

    hideFieldGroup(subjectField);
    hideFieldGroup(pageContextField);
    hideFieldGroup(pagePathField);
    hideFieldGroup(templateContextField);

    form.dataset.contextualQuoteReady = 'true';
  });
};

document.addEventListener('DOMContentLoaded', initContextualQuoteForms);
document.addEventListener('turbo:load', initContextualQuoteForms);

export default initContextualQuoteForms;
